import { useMutation } from "@tanstack/react-query";
import type { UseMutationOptions } from "@tanstack/react-query";

import type { GenerateOtcResponse } from "@/core/types";

import { generateOtc } from "../queryFunctions/generateOtc";

export function useGenerateOtc(
  options: UseMutationOptions<GenerateOtcResponse, unknown, { patientId: string }> = {},
) {
  return useMutation({ ...options, mutationFn: generateOtc });
}
